import { PublishedAsset } from "@ncs/ncs-api/portal-apps/point-of-sale/types"
import { buttonStyle, imageRendererStyle, imageStyle } from "./styles"
import Icon360 from "./Icon360"

type ThumbRendererProps = {
	asset: PublishedAsset
	onClick: () => void
	isSelected: boolean
	priority: "auto" | "high" | "low"
}

const ThumbRenderer: React.FC<ThumbRendererProps> = ({
	asset,
	onClick,
	isSelected,
	priority = "auto",
}) => {
	const is360 = asset.assetRole === "360"

	return (
		<button
			onClick={onClick}
			css={buttonStyle}
			type="button"
			aria-pressed={isSelected}
			aria-label={
				is360 ?
					`${asset.assetName || "360 view"} thumbnail`
				:	`${asset.assetName || "Image"} thumbnail`
			}
		>
			<figure
				css={imageRendererStyle(isSelected)}
				role="group"
				aria-label={
					is360 ? "360-degree image preview" : `${asset.assetName || "Image preview"}`
				}
			>
				{is360 ?
					<Icon360 aria-hidden="true" />
				:	<img
						src={asset.assetUrl}
						alt={asset.assetName || "Product image"}
						css={imageStyle}
						loading="lazy"
						fetchpriority={priority}
					/>
				}
			</figure>
		</button>
	)
}

export default ThumbRenderer
